import { render, staticRenderFns } from "./MaterialView.vue?vue&type=template&id=21b813b1&"
import script from "./MaterialView.vue?vue&type=script&lang=ts&"
export * from "./MaterialView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports